export default __webpack_public_path__ + "static/media/About.07b0e489.svg";